const types = {
  SET_VOTE_RATINGS: "SET_VOTE_RATINGS",
  SET_VOTE_BEHAVIORS: "SET_VOTE_BEHAVIORS",
  SET_MY_VOTES: "SET_MY_VOTES",
};

export default types;
